import React, { useContext, Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '../../../../../components/Table/StripedTable';
import { store } from './Fleets';
import { __ } from '../../../../../utils/i18n';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import YesNo from '../../../../../components/Dialog/YesNo';
import useRules from "../../../../../hooks/useRules";

const useStyles = makeStyles((theme) => ({
  fleetsTable: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit,minmax(380px,1fr))',
    gridGap: theme.spacing(1),
  },
  green: {
    color: green[500],
  },
  red: {
    color: red[500],
  },
}));

const FleetsTable = () => {
  const classes = useStyles();
  const [rules,hasRule,isAdmin] = useRules();
  const { state, dispatch, doDeleteFleet, doDeleteFleetOption } = useContext(
    store
  );
  const { fleets, fleetOptions } = state;
  const [deleteFleet, setDeleteFleet] = useState(null);
  const [deleteFleetOption, setDeleteFleetOption] = useState(null);

  const handleEditFleet = (fleet) => {
    dispatch({ type: 'SHOW_ADD_FLEET_DIALOG', payload: fleet });
  };
  const handleEditFleetOption = (fleetOption) => {
    dispatch({ type: 'SHOW_ADD_FLEET_OPTIONS_DIALOG', payload: fleetOption });
  };
  const handleDeleteFleet = (agree) => {
    agree && doDeleteFleet(deleteFleet);
    setDeleteFleet(null);
  };
  const handleDeleteFleetOption = (agree) => {
    agree && doDeleteFleetOption(deleteFleetOption);
    setDeleteFleetOption(null);
  };

  return (
    <Fragment>
      {deleteFleet ? (
        <YesNo
          onClose={handleDeleteFleet}
          text="آیا از حذف این ناوگان مطمئن هستید؟"
          fullWidth={false}
        />
      ) : null}
      {deleteFleetOption ? (
        <YesNo
          onClose={handleDeleteFleetOption}
          text="آیا از حذف این ویژگی ناوگان مطمئن هستید؟"
          fullWidth={false}
        />
      ) : null}
      <div className={`${classes.fleetsTable} fleets`}>
        <div>
          <Table
            thArray={['نام', 'واحدوزن', 'وزن', 'ویرایش', 'حذف']}
            tdArray={fleets.map((f) => [
              f.title,
              __(f.weightType),
              f.weightType === 'Kg' ? f.maxWeight * 1000 : f.maxWeight,
              <IconButton
                className={classes.green}
                onClick={() => handleEditFleet(f)}
              >
                <EditIcon />
              </IconButton>,
              isAdmin?<IconButton
                className={classes.red}
                onClick={() => {
                  setDeleteFleet(f._id);
                }}
              >
                <DeleteIcon />
              </IconButton>:'',
            ])}
          />
        </div>
        <div>
          <Table
            thArray={['ویژگی', 'ناوگان', 'درصد موثر', 'ویرایش', 'حذف']}
            tdArray={fleetOptions.map((fo) => [
              fo.title,
              fo.fleet.title,
              `${fo.effectivePercentage} %`,
              <IconButton
                className={classes.green}
                onClick={() => handleEditFleetOption(fo)}
              >
                <EditIcon />
              </IconButton>,
              isAdmin?<IconButton
                className={classes.red}
                onClick={() => {
                  setDeleteFleetOption(fo._id);
                }}
              >
                <DeleteIcon />
              </IconButton>:'',
            ])}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default FleetsTable;
